export default { sha: '2e8d9fae3a7ceec4b8c8d9ad5fc08fecfc333787', buildNumber: 'undefined' }
